/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Link = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 16 16" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15.94 1L16 7a1 1 0 0 1-1 .94A1 1 0 0 1 14 7V3.38L8.68 8.71a1 1 0 0 1-1.39 0 1 1 0 0 1 0-1.38L12.54 2H8.89a1 1 0 0 1-1-1 1 1 0 0 1 .94-1l6-.06H15a.88.88 0 0 1 .58.23l.08.05.05.07a.89.89 0 0 1 .23.59V1zM2 4v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-2h2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v2H3a1 1 0 0 0-1 1z" fillRule="evenodd" />
      </g>
    </svg>
  </span>
);

Link.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Link.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Link;
